<template>
    <pappas-leads-form concept="pappas-corporate" :include-styles="false" :api-base="apiBase" :test-mode="testMode" :exclude-subjects="excludedSubjects" :exclude-concepts="excludedConcepts"></pappas-leads-form>
</template>

<script setup>
defineProps({ 
    apiBase: { type: String, default: 'https://dashboard.pappas.com/api' },
    testMode: { type: Boolean, default: false }, 
});

const excludedSubjects = [
    'gift-cards',
    'catering',
    'catering-inquiry',
    'allergies',
    'promotions',
    'recipes',
    'donations',
    'request-a-restaurant-in-my-area',
    'dress_code',
    'community_relations',
    'employee_feedback',
];

const excludedConcepts = [
    'pappas-catering',
    'pappas-delivery',
    'ontheborder',
    'fuddruckers',
    'pappas-corporate',
    'pappas-gift-card',
    'pappasitos-otb',
];


// Catering, delivery, otb, potb
</script>
